<template>
	<div>
		<v-dialog v-model="dialog_filter_items" no-click-animation persistent scrollable content-class="select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<!-- <v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>{{title}}</v-subheader>
	        	</v-card-title>
	        	
	        	<v-divider></v-divider> -->

		        <v-card-text full-height nopadding>

		        	<v-subheader>Filter {{type}} By</v-subheader>

			        <v-divider></v-divider>

			        <v-list nopadding>

			        	<!-- <v-list-tile v-for="(item, index) in filterData.filterItems" :key="index" @click="setFilter(item.filterItemId)"> -->
			        	<v-list-tile v-for="(item, index) in filterData.filterItems" :key="item.filterItemId" @click="fn_selectFilter(item.value)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.name}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item.value == currentFilterValue">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>
			        	</v-list-tile>

			        	<v-divider></v-divider>

			        	<v-subheader>Sort {{type}} By</v-subheader>

			        	<v-divider></v-divider>

			        	<v-list-tile v-for="(item, index) in filterData.sortItems" :key="item.sortId" @click="fn_selectSort(item.value)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.name}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item.value == currentSortValue">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>
			        	</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile>

							<v-list-tile-action>
						        <v-checkbox v-model="showDeactivatedOnly"></v-checkbox>
				            </v-list-tile-action>

				            <v-list-tile-content>
				              <v-list-tile-title>Show Deactivated Only</v-list-tile-title>
				            </v-list-tile-content>
				            
			        	</v-list-tile>
			        </v-list>
		        </v-card-text>

		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click="fn_closDialog">close</v-btn>
		          <v-btn color="blue darken-1" flat @click="setFilter(currentFilterValue, currentSortValue, showDeactivatedOnly)">Done</v-btn>
		        </v-card-actions>
		       <!--  <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions> -->
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['type', 'filterData', 'setFilter', 'selectedFilterItemValue', 'selectedSortValue', 'deactivatedOnly'],
		data(){
			return{
				dialog_filter_items:false,
				currentFilterValue:null,
				currentSortValue:null,
				showDeactivatedOnly:false
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_filter_items = true;
				this.currentFilterValue = this.selectedFilterItemValue;
				this.currentSortValue = this.selectedSortValue;
				this.showDeactivatedOnly = this.deactivatedOnly
			},
			closeDialogWeb: function () {
				this.dialog_filter_items = false;
			},
			fn_selectFilter: function(value){
				this.currentFilterValue = value;
			},
			fn_selectSort: function(value){
				this.currentSortValue = value;
			},
			fn_closDialog: function(){
				if(this.$parent.fn_closeDialog){
					this.$parent.fn_closeDialog();
				}
				else{
					this.closeDialogWeb();
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/activity/dialogs/dialog_filter.vue